<template>
  <a-card class="style1">
    <a-table :loading="isLoading" :columns="columns" :data-source="accountList" :pagination="pagination" @change="handleTableChange" size="middle" bordered :scroll="{ x: 1500 }" rowKey="id">
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px;">
        <a-input
          v-ant-ref="c => (searchInput = c)"
          :placeholder="`Search ${column.title}`"
          :value="selectedKeys[0]"
          style="width: 190px; margin-bottom: 8px; display: block;"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
        />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px;" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
        <a-button size="small" style="width: 90px;" @click="() => handleReset(clearFilters)">Reset</a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
      <template slot="name" slot-scope="record">
        <a href="javascript:;" @click="$router.push({ name: 'AdminAccountDetail', params: { account_id: record.id } })">{{ record.name }}</a>
      </template>
      <template slot="profile_description" slot-scope="text">
        <div v-html="text"></div>
      </template>
      <template slot="profile_service_times" slot-scope="text">
        <div v-html="text"></div>
      </template>
      <template slot="profile_contact_details" slot-scope="text">
        <div v-html="text"></div>
      </template>
      <div slot="action" slot-scope="record" class="action">
        <a href="javascript:;" @click="onEdit(record)">Edit</a>
        <a-popconfirm title="Are you sure？" ok-text="Yes" cancel-text="No" @confirm="onDelete(record)">
          <a href="javascript:;">Delete</a>
        </a-popconfirm>
      </div>
    </a-table>

    <a-modal v-model="isVisibleModal" title="Update user information" centered @ok="handleSubmit" :destroyOnClose="true" :closable="true" :maskClosable="false" class="accountEdit">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Return</a-button>
        <a-button key="submit" type="primary" :loading="isLoading" @click="handleSubmit">Submit</a-button>
      </template>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item label="Church Name">
          <a-input size="large" placeholder="Church name" v-decorator="['name', { rules: [{ required: true, message: 'Please input church name!' }] }]" />
        </a-form-item>
        <a-form-item label="Church Description">
          <wysiwyg
            v-model="profile_description"
            v-decorator="[
              'profile_description',
              {
                rules: [
                  {
                    required: true,
                    validator: (rule, value, callback) => validateInput(rule, value, callback, 'Please input Church Description!'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Contact Details">
          <wysiwyg v-model="profile_contact_details" v-decorator="['profile_contact_details']" />
        </a-form-item>
        <a-form-item label="Service Times">
          <wysiwyg v-model="profile_service_times" v-decorator="['profile_service_times']" />
        </a-form-item>
        <a-tag color="red" class="w-100 p-1" v-if="!empty(error)">{{ error }}</a-tag>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import AdminService from '@/services/AdminService';
import { slugData, empty } from '@/utils';
import { get, includes } from 'lodash';
export default {
  data() {
    return {
      accountList: [],
      form: this.$form.createForm(this),
      accountEdit: {},
      error: '',
      isLoading: true,
      pagination: [],
      isVisibleModal: false,
      profile_contact_details: '',
      profile_description: '',
      profile_service_times: '',
      columns: [
        {
          title: 'Church',
          key: 'name',
          width: 150,
          scopedSlots: {
            customRender: 'name',
          },
        },
        {
          title: 'Reculy Code',
          key: 'recurly_code',
          dataIndex: 'recurly_code',
        },
        {
          title: 'Profile Description',
          dataIndex: 'profile_description',
          key: 'profile_description',
          scopedSlots: {
            customRender: 'profile_description',
          },
        },
        {
          title: 'Profile Service Times',
          dataIndex: 'profile_service_times',
          key: 'profile_service_times',
          scopedSlots: {
            customRender: 'profile_service_times',
          },
        },
        {
          title: 'Profile Contact Details',
          dataIndex: 'profile_contact_details',
          key: 'profile_contact_details',
          scopedSlots: {
            customRender: 'profile_contact_details',
          },
        },
        {
          title: 'Action',
          key: 'operation',
          fixed: 'right',
          width: 100,
          scopedSlots: {
            customRender: 'action',
          },
        },
      ].map(item => {
        if (item.key !== 'operation') {
          return {
            ...item,
            scopedSlots: {
              ...item.scopedSlots,
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
            },
            onFilter: (value, record) => record[this.searchedColumn] && includes(slugData(record[this.searchedColumn]), slugData(value)),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus();
                }, 0);
              }
            },
          };
        }
        return item;
      }),
    };
  },
  async created() {
    try {
      this.isLoading = true;
      await this.doInitData();
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    empty,
    async doInitData() {
      await this.fetchAccounts();
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetchAccounts({
        limit: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
      });
    },
    async fetchAccounts(params = {}) {
      this.isLoading = true;

      const data = await AdminService.account.getAll({
        limit: 10,
        ...params,
      });

      const pagination = { ...this.pagination };
      pagination.total = data.total_count;
      this.pagination = pagination;

      this.accountList = data.accounts;
      this.isLoading = false;
    },
    async onDelete(record) {
      try {
        this.isLoading = true;
        await AdminService.account.delete(record.id);
        this.$notification['success']({
          message: 'Delete successful.',
          description: `${record.name} was deleted successfully.`,
        });
        await this.doInitData();
      } catch (error) {
        console.error({ error });
      } finally {
        this.isLoading = false;
      }
    },
    validateInput(rule, value, callback, message) {
      if (empty(value) || value === '<br>') {
        return callback(message);
      }
      callback();
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },

    handleReset(clearFilters) {
      clearFilters();
    },
    handleCancel() {
      this.accountEdit = {};
      this.isVisibleModal = false;
    },
    onEdit(record) {
      this.accountEdit = record;

      this.profile_contact_details = record.profile_contact_details;
      this.profile_description = record.profile_description;
      this.profile_service_times = record.profile_service_times;
      this.isVisibleModal = true;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: record.name,
          profile_description: this.profile_description,
          profile_contact_details: this.profile_contact_details,
          profile_service_times: this.profile_service_times,
        });
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.error = '';
            this.isLoading = true;
            await AdminService.account.update(this.accountEdit.id, values);
            await this.doInitData();
            this.isVisibleModal = false;
          } catch (error) {
            console.error({ error });
            this.error = get(error, 'response.data.error', error.message);
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
.accountEdit .ant-modal {
  padding: 0 10px;
  width: 100% !important;
  max-width: 800px;
}
</style>
